import JsonRefs from 'json-refs';

export const resolveRefs = JsonRefs.resolveRefs;
